import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { KNZUtilModule } from '@knz/util';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { ResultComponent } from './result.component';

const COMPONENTS = [ResultComponent];

@NgModule({
  imports: [CommonModule, NzIconModule, KNZUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class ResultModule {}
